import { useMemo } from "react";
import { useFeaturesReady } from "../../context/featuresReady/FeaturesReadyContext";
import { getFeature } from "../../utils/features";

interface SyndicateReviewsExperimentResult {
  isFiltered: boolean;
}

export default function useSyndicateReviewsExperiment(
  isEligible: boolean,
): SyndicateReviewsExperimentResult {
  const { areFeaturesReady } = useFeaturesReady() as {
    areFeaturesReady: boolean;
  };

  return useMemo(() => {
    if (!areFeaturesReady || !isEligible) {
      return { isFiltered: false };
    }

    const { isEnabled, getVariables } = getFeature("web-pdp-syndicate-reviews");
    const variables = getVariables() as { bucket?: string } | null;

    return {
      isFiltered: isEnabled() && variables?.bucket === "v1",
    };
  }, [areFeaturesReady, isEligible]);
}
